import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { updateRoute } from "../store/slices/common-slice/route/RouteSlice";

const RouteTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateRoute(location.pathname));
  }, [dispatch, location.pathname]);

  return null;
};

export default RouteTracker;
